import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MoreVert } from '../ui/Icons';

const PencilIcon = (props) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    sx={{ width: props.size || 18, height: props.size || 18 }}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </Box>
);

/**
 * Per-row action cluster: a pencil button that opens the edit drawer plus a
 * three-dot menu for less-frequent actions (manage add-ons, schedule, delete).
 */
const MenuItemActionsMenu = ({ item, onEdit, onManageAddons, onSchedule, onDelete }) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  return (
    <Box sx={{ display: 'inline-flex', gap: 0.5 }}>
      <IconButton size="small" onClick={() => onEdit?.(item)} aria-label={t('common.edit', 'Edit')}>
        <PencilIcon size={18} />
      </IconButton>
      <IconButton
        size="small"
        onClick={(e) => { e.stopPropagation(); setAnchor(e.currentTarget); }}
        aria-label={t('common.more', 'More actions')}
      >
        <MoreVert size={18} />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {onManageAddons && (
          <MenuItem onClick={() => { close(); onManageAddons(item); }}>
            <ListItemText>{t('menuV2.actions.manageAddOns', 'Manage Add-Ons')}</ListItemText>
          </MenuItem>
        )}
        {onSchedule && (
          <MenuItem onClick={() => { close(); onSchedule(item); }}>
            <ListItemText>{t('menuV2.actions.schedule', 'Schedule availability')}</ListItemText>
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem onClick={() => { close(); onDelete(item.id); }} sx={{ color: 'error.main' }}>
            <ListItemText>{t('common.delete', 'Delete')}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default MenuItemActionsMenu;
